export class Configuracao {
    public static readonly VALOR_MAXIMO_CACAUS = 'ValorMaximoCacaus';

    id: number;
    descricao: string;
    valor: string;
    ativo: boolean;
    valorFormatado: number | string | boolean;
}